import { Component } from '@angular/core';
import * as Constants from '@emi/shared/constants';

@Component({
  selector: 'via-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  public contactUsRoute = '/' + Constants.Routes.CONTACT_US;
}
